import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Header for a wizard that render a title, a description and a cancel button.
 *
 * @param {Wizard} wizard - Wizard upon which to act
 * @param {Renderable} title - Title of the WizardWidget
 * @param {Renderable} [description] - Description of the WizardWidget
 */
export default class CancellingWizardHeaderWidget extends Widget {
	constructor({ wizard, title, description }) {
		super(...arguments);
		this._wizard = wizard;
		this._title = title;
		this._description = description;
	}

	renderContentOn(html) {
		html.div(
			{ class: "CancellingWizardHeaderWidget" },
			html.div(
				{ class: "content-container" },
				html.div({ class: "title" }, html.h3(this._title)),
				this._renderDescriptionOn.bind(this),
			),
		);
	}

	_renderDescriptionOn(html) {
		if (!this._description) {
			return;
		}

		html.div({ class: "description" }, html.p(this._description));
	}

	_closeWizard() {
		this._wizard.aborted.trigger();
	}
}
